import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
	plugins: [createPersistedState()],
	state: {
		loyaltyType: null,
		business: {
			info: {},
			contact: {},
			address: {},
			cardinfo: null
		},
		personal: {
			info: {},
			address: {},
			cardinfo: {}
		}
	},
	mutations: {
		resetStateProperties(state) {
			(state.loyaltyType = null),
				(state.business.info = {}),
				(state.business.contact = {}),
				(state.business.address = ''),
				(state.business.cardinfo = null),
				(state.personal.info = {}),
				(state.personal.address = {}),
				(state.personal.cardinfo = {});
		},
		setApplicationChoice(state, payload) {
			state.loyaltyType = payload;
		},
		STORE_BUSINESS_INFO(state, payload) {
			state.business.info = payload;
		},
		SAVE_BUSINESS_CONTACT(state, payload) {
			state.business.contact = payload;
		},
		SAVE_BUSINESS_ADDRESS(state, payload) {
			state.business.address = payload;
		},
		SAVE_BUSINESS_CARD_DETAILS(state, payload) {
			state.business.cardinfo = payload;
		},
		STORE_PERSONAL_INFO(state, payload) {
			state.personal.info = payload;
		},
		SAVE_PERSONAL_ADDRESS(state, payload) {
			state.personal.address = payload;
		},
		SAVE_PERSONAL_CARD_DETAILS(state, payload) {
			state.personal.cardinfo = payload;
		}
	},
	actions: {}
});
